// Messages de validation communs à tous les domaines (API et formulaires du BO), sans dépendance :
// un module de domaine (logistique, adresse…) les importe, jamais l'inverse.

/** Texte trop long : même message partout. */
export const maxLengthMessage = (max: number): string => `${max} caractères au plus.`

/**
 * Nom d'une entité vide (ou seulement des espaces) : même message à l'API et dans le formulaire
 * (transporteurs).
 */
export const NAME_REQUIRED_MESSAGE = 'Le nom est requis.'

/**
 * Adresse email refusée (format) : même message à l'API et dans les formulaires (transporteurs,
 * collaborateurs).
 */
export const INVALID_EMAIL_MESSAGE = 'Adresse email invalide.'

/**
 * Mot de passe refusé par sa règle (`PASSWORD_REGEX` de `@gozoki/tools`, après retrait des espaces
 * de tête et de fin) : même message à l'API (réinitialisation par code) et dans les formulaires du
 * BO (`passwordRuleSchema`).
 */
export const PASSWORD_RULE_MESSAGE =
  'Le mot de passe doit contenir au moins 8 caractères, une lettre, un chiffre et un caractère spécial.'
